import axios from 'axios';
import qs from "qs";

const getDomainLogEvents = ({url,data}) => axios.post(`${url}/index.php?r=ApprendoLog/GetData`, qs.stringify({data: data}));


export default {
    getDomainLogEvents
};
